import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { View } from 'react-native'
import styled from 'styled-components/native'

import CenteredSpinner from '../../Atoms/Spinner/CenteredSpinner'
import InlineError from '../../Atoms/InlineError'
import { Text } from '../../Atoms/Typography'
import Alert from '../../Atoms/Alert'

import { formatParticipantName } from '../../../lib/formatters'

import { clearCeoTransferData, fetchParticipants, createCEOTransferRequest, cancelCeoTransferRequest } from '../../../redux/participants'
import OptionsAlert from '../../Molecules/OptionsAlert'

const SpinnerContainer = styled(View)`
  height: 100px;
`

class CEOTransfer extends PureComponent {
  state = {
    selectedParticipantId: null,
    error: null
  }

  componentDidUpdate (prevProps) {
    if (!prevProps.cancelCeoTransferRequest && this.props.cancelCeoTransferRequest) {
      this.props.onCancel()
    }

    if (this.props.ceoTransferRequestParticipantId && this.props.ceoTransferRequestParticipantId !== prevProps.ceoTransferRequestParticipantId) {
      this.setState({ selectedParticipantId: this.props.ceoTransferRequestParticipantId })
    }
  }

  componentDidMount () {
    this.props.fetchParticipants()
    if (this.props.ceoTransferRequestParticipantId) {
      this.setState({ selectedParticipantId: this.props.ceoTransferRequestParticipantId })
    }
  }

  handleSelectingDeviceId = (participantId) => {
    this.setState({ selectedParticipantId: participantId, error: null })
  }

  handleSubmit = () => {
    if (!this.state.selectedParticipantId) {
      return this.setState({ error: 'Please select the new CEO' })
    }
    this.props.createCEOTransferRequest({ requestedDeviceId: this.state.selectedParticipantId })
  }

  handleCancel = () => {
    this.props.cancelCeoTransferRequest()
  }

  renderSpinner = () => {
    return (
      <SpinnerContainer>
        <CenteredSpinner />
      </SpinnerContainer>
    )
  }

  handleClose = () => {
    this.props.clearCeoTransferData()
    this.props.onCancel()
  }

  renderParticipants = () => {
    let error = this.state.error || (this.props.ceoTransferRequestError && this.props.ceoTransferRequestError.message)
    if (/does not exist/.test(error)) {
      const participant = this.props.participants.find(p => p.id === this.state.selectedParticipantId)
      let participantName = 'Your teammate'
      if (participant) {
        participantName = formatParticipantName(participant)
      }
      error = `${participantName} is not currently signed in to accept your request`
    }
    return (
      <OptionsAlert
        visible
        onCancel={this.handleClose}
        onConfirm={this.handleSubmit}
        confirmInProgress={this.props.ceoTransferRequestInProgress}
        error={error}
        isLoading={this.props.isLoading}
        title='Select the new CEO'
        emptyTitle='CEO transfer not possible'
        emptyText='There are no other team members to transfer to'
        options={!!this.props.participants.length &&
          this.props.participants.filter(p => p.id !== this.props.deviceId).map(o => {
            return {
              value: o.id,
              name: formatParticipantName(o),
              handlePress: () => this.handleSelectingDeviceId(o.id),
              disabled: this.props.ceoTransferRequestInProgress,
              selected: this.state.selectedParticipantId === o.id
            }
          })}
      />
    )
  }

  renderCancelling = () => {
    if (this.props.cancelCeoTransferRequestError) {
      return (
        <Alert visible>
          <Text bold>Error while cancelling...</Text>
          <InlineError message={this.props.cancelCeoTransferRequestError.message} />
        </Alert>
      )
    }
    return (
      <Alert visible>
        <Text bold>Cancelling...</Text>
        {this.renderSpinner()}
      </Alert>
    )
  }

  renderWaiting = () => {
    return (
      <Alert visible onCancel={this.handleCancel}>
        {!!this.props.participants.length && this.state.selectedParticipantId && <Text bold>Waiting for {formatParticipantName(this.props.participants.find(p => p.id === this.state.selectedParticipantId))} to accept</Text>}
        {this.renderSpinner()}
      </Alert>
    )
  }

  renderConfirmation = () => {
    return (
      <Alert visible onConfirm={this.handleClose}>
        {!!this.props.participants.length && this.state.selectedParticipantId && <Text bold>{formatParticipantName(this.props.participants.find(p => p.id === this.state.selectedParticipantId))} has {this.props.ceoTransferRequestStatus} your request</Text>}
      </Alert>
    )
  }

  render () {
    const cancelling = this.props.cancelCeoTransferRequestInProgress || this.props.cancelCeoTransferRequestError
    if (cancelling) {
      return this.renderCancelling()
    }
    const waitingResult = this.props.ceoTransferRequestComplete && !this.props.ceoTransferRequestStatus
    const confirmationReceived = this.props.ceoTransferRequestStatus
    const renderer = confirmationReceived ? this.renderConfirmation : waitingResult ? this.renderWaiting : this.renderParticipants
    return renderer()
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.participants.isLoading,
  isLoaded: state.participants.isLoaded,
  participants: state.participants.participants,
  deviceId: state.device.deviceId,
  ceoTransferRequestParticipantId: state.participants.ceoTransferRequestParticipantId,
  ceoTransferRequestInProgress: state.participants.ceoTransferRequestInProgress,
  ceoTransferRequestComplete: state.participants.ceoTransferRequestComplete,
  ceoTransferRequestError: state.participants.ceoTransferRequestError,
  ceoTransferRequestStatusInProgress: state.participants.ceoTransferRequestStatusInProgress,
  ceoTransferRequestStatus: state.participants.ceoTransferRequestStatus,
  ceoTransferRequestStatusError: state.participants.ceoTransferRequestStatusError,
  cancelCeoTransferRequestInProgress: state.participants.cancelCeoTransferRequestInProgress,
  cancelCeoTransferRequest: state.participants.cancelCeoTransferRequest,
  cancelCeoTransferRequestError: state.participants.cancelCeoTransferRequestError
})

export default connect(mapStateToProps, { clearCeoTransferData, fetchParticipants, createCEOTransferRequest, cancelCeoTransferRequest })(CEOTransfer)
